import { render, staticRenderFns } from "./anamnese-historique.html?vue&type=template&id=89dac34e&scoped=true&external"
import script from "./anamnese-historique.js?vue&type=script&lang=js&external"
export * from "./anamnese-historique.js?vue&type=script&lang=js&external"
import style0 from "./anamnese-historique.scss?vue&type=style&index=0&id=89dac34e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89dac34e",
  null
  
)

export default component.exports